export const toAbsoluteUrl = (pathname: string) => {
    // TODO: not using Cloudfront for SVGs. Workaround until
    // we get Cloudfront to work with SVGs.
    if (pathname.endsWith('.svg')) {
        return process.env.PUBLIC_URL + pathname;
    }
    return (process.env.REACT_APP_CLOUDFRONT_URL || process.env.PUBLIC_URL) + pathname;
}
